import { render } from "./BloodRelativesDiagram.vue?vue&type=template&id=087bd10f&scoped=true"
import script from "./BloodRelativesDiagram.vue?vue&type=script&lang=js"
export * from "./BloodRelativesDiagram.vue?vue&type=script&lang=js"

import "./BloodRelativesDiagram.vue?vue&type=style&index=0&id=087bd10f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087bd10f"]])

export default __exports__